import { render, staticRenderFns } from "./RepProvince.vue?vue&type=template&id=fcbc5b2a&"
import script from "./RepProvince.vue?vue&type=script&lang=js&"
export * from "./RepProvince.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports